/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spoiler_OnInputs */

const th_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหมดซ่อนผล — ไม่แสดงคะแนน`)
};

const en_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spoiler mode on — scores hidden`)
};

const ja_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネタバレ防止中 — スコア非表示`)
};

const zh_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防剧透已开启——比分已隐藏`)
};

const es_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo sin resultados activado: resultados ocultos`)
};

const pt_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo sem spoiler ligado — placares ocultos`)
};

const id_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode tanpa bocoran aktif — skor disembunyikan`)
};

const fr_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode sans spoiler activé — scores masqués`)
};

const tl_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktibo ang walang spoiler — nakatago ang mga iskor`)
};

const vi_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giấu kết quả — tỉ số bị ẩn`)
};

const ko_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스포일러 방지 켜짐 — 점수를 숨깁니다`)
};

const de_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spoilerfrei aktiv — Ergebnisse verborgen`)
};

const ru_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим без спойлеров включён — счёт скрыт`)
};

const tr_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sürpriz bozmaz açık — skorlar gizli`)
};

const it_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità senza spoiler attiva — punteggi nascosti`)
};

const pl_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tryb bez spoilerów włączony — wyniki ukryte`)
};

const uk_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим без спойлерів увімкнено — рахунок приховано`)
};

const hi_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पॉइलर से बचाव चालू — स्कोर छिपे हैं`)
};

const ar_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وضع عدم الحرق مفعّل — النتائج مخفية`)
};

const ms_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mod tanpa bocoran aktif — mata disembunyikan`)
};

const bn_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফল ফাঁস নয় চালু — স্কোর লুকানো`)
};

const zh_tw2_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防劇透已開啟——比分已隱藏`)
};

const zh_hk2_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防劇透已開啟——比分已隱藏`)
};

const ur_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتیجہ نہ بتائیں چالو — اسکور چھپے ہوئے`)
};

const fa_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالت بدون لو دادن روشن — نتایج پنهان است`)
};

const sw_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hali ya kutofichua imewashwa — matokeo yamefichwa`)
};

const nl_spoiler_on = /** @type {(inputs: Spoiler_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonder spoilers staat aan — standen verborgen`)
};

/**
* | output |
* | --- |
* | "Spoiler mode on — scores hidden" |
*
* @param {Spoiler_OnInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const spoiler_on = /** @type {((inputs?: Spoiler_OnInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spoiler_OnInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_spoiler_on(inputs)
	if (locale === "ja") return ja_spoiler_on(inputs)
	if (locale === "zh") return zh_spoiler_on(inputs)
	if (locale === "es") return es_spoiler_on(inputs)
	if (locale === "pt") return pt_spoiler_on(inputs)
	if (locale === "id") return id_spoiler_on(inputs)
	if (locale === "fr") return fr_spoiler_on(inputs)
	if (locale === "tl") return tl_spoiler_on(inputs)
	if (locale === "vi") return vi_spoiler_on(inputs)
	if (locale === "ko") return ko_spoiler_on(inputs)
	if (locale === "de") return de_spoiler_on(inputs)
	if (locale === "ru") return ru_spoiler_on(inputs)
	if (locale === "tr") return tr_spoiler_on(inputs)
	if (locale === "it") return it_spoiler_on(inputs)
	if (locale === "pl") return pl_spoiler_on(inputs)
	if (locale === "uk") return uk_spoiler_on(inputs)
	if (locale === "hi") return hi_spoiler_on(inputs)
	if (locale === "ar") return ar_spoiler_on(inputs)
	if (locale === "ms") return ms_spoiler_on(inputs)
	if (locale === "bn") return bn_spoiler_on(inputs)
	if (locale === "zh-TW") return zh_tw2_spoiler_on(inputs)
	if (locale === "zh-HK") return zh_hk2_spoiler_on(inputs)
	if (locale === "ur") return ur_spoiler_on(inputs)
	if (locale === "fa") return fa_spoiler_on(inputs)
	if (locale === "sw") return sw_spoiler_on(inputs)
	if (locale === "nl") return nl_spoiler_on(inputs)
	return en_spoiler_on(inputs)
});